import { render, staticRenderFns } from "./r-input.vue?vue&type=template&id=4de64e21&scoped=true"
import script from "./r-input.vue?vue&type=script&lang=js"
export * from "./r-input.vue?vue&type=script&lang=js"
import style0 from "./r-input.vue?vue&type=style&index=0&id=4de64e21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de64e21",
  null
  
)

export default component.exports